import Vue from 'vue'
import { get, post } from './request.js'

// const baseURL = 'https://api.dianyuan.com/'
// const eestarURL = 'https://api.eestar.com/'
// export const domainname = 'https://act.dianyuan.com'
// export const weixinAuthorizationURL = 'https://www.dianyuan.com/wechat/page/weixinOuth?acturl='

// const baseURL = 'https://apidev.dianyuan.com/'
// const eestarURL = 'http://eestar.dev.dianyuan.com/'
// export const domainname = 'https://actdev.dianyuan.com'
// export const weixinAuthorizationURL= 'https://dev.dianyuan.com/wechat/page/weixinOuth?acturl='
const baseURL = process.env.BASE_URL
const eestarURL = process.env.EESTAR_URL
const newBaseUrl = process.env.NEW_BASE_URL
export const domainname = process.env.DOMAIN_NAME
export const weixinAuthorizationURL = process.env.WEIXIN_Authorization_URL

export const dutyjson = p => get('https://www.dianyuan.com/json/user/duty.json', p) // 职责
Vue.prototype.$dutyjson = dutyjson
export const postjson = p => get('https://www.dianyuan.com/json/user/post.json', p) // 职务
Vue.prototype.$postjson = postjson
export const productjson = p => get('https://www.dianyuan.com/json/user/product.json', p) // 产品、行业
Vue.prototype.$productjson = productjson
export const sciencejson = p => get('https://www.dianyuan.com/json/user/science.json', p) // 感兴趣的技术
Vue.prototype.$sciencejson = sciencejson

export const dgkpostjson = (p) => get("https://www.dianyuan.com/json/user/post_dgk.json", p); // 职务(dgk)
Vue.prototype.$dgkpostjson = dgkpostjson
export const dgkindustryjson = (p) => get("https://www.dianyuan.com/json/user/industry_dgk.json", p); // 行业(dgk)
Vue.prototype.$dgkindustryjson = dgkindustryjson
export const dgkareajson = (p) => get("https://www.dianyuan.com/json/user/area_dgk.json", p); // 地区(dgk)
Vue.prototype.$dgkareajson = dgkareajson

export const publicactPerson = p => post(baseURL + 'scrm/activity/person', p)
Vue.prototype.$publicactPerson = publicactPerson// 公共活动获取用户基本信息
export const activityShow = p => post(baseURL + 'scrm/activity/show', p)// 转盘公共抽奖获取抽奖信息
Vue.prototype.$activityShow = activityShow
export const activityGetLucky = p => post(baseURL + 'scrm/activity/getLucky', p)// 转盘公共抽奖获取抽奖信息
Vue.prototype.$activityGetLucky = activityGetLucky
export const activityInfo = p => post(baseURL + 'scrm/activity/info', p)// 公共活动介绍页
Vue.prototype.$activityInfo = activityInfo
export const scrmActivityjoinAct = p => post(baseURL + 'scrm/activity/joinAct', p)// 公共活动参加
Vue.prototype.$scrmActivityjoinAct = scrmActivityjoinAct

/* 之前的老的获取职位职称产品领域 */
export const get_data = p => post(baseURL + 'user/profile/get_data', p)// 转盘公共抽奖获取抽奖信息
Vue.prototype.$get_data = get_data

export const getJsSdkSign = p => get(newBaseUrl + 'wechat/weixin/getJsSdkSign', p)
Vue.prototype.$getJsSdkSign = getJsSdkSign

export const getInfo = p => post(baseURL + 'page/gather0614/qrSubmit', p)
Vue.prototype.$getInfo = getInfo
export const sendCode = p => post(baseURL + 'page/gather0614/sendCode', p)
Vue.prototype.$sendCode = sendCode
export const formSubmit = p => post(baseURL + 'page/gather0614/formSubmit', p)
Vue.prototype.$formSubmit = formSubmit
export const vicorSubmit = p => post(baseURL + 'page/gather0614/vicorSubmit', p)
Vue.prototype.$vicorSubmit = vicorSubmit
export const dahuaSubmit = p => post(baseURL + 'page/gather0614/dahuaSubmit', p)
Vue.prototype.$dahuaSubmit = dahuaSubmit
export const rohmSubmit = p => post(baseURL + 'page/gather0614/rohmSubmit', p)
Vue.prototype.$rohmSubmit = rohmSubmit
export const keysightSubmit = p => post(baseURL + 'page/gather0614/keysightSubmit', p)
Vue.prototype.$keysightSubmit = keysightSubmit
export const flukeSubmit = p => post(baseURL + 'page/gather0614/flukeSubmit', p)
Vue.prototype.$flukeSubmit = flukeSubmit
export const adiSubmit = p => post(baseURL + 'page/gather0614/adiSubmit', p)
Vue.prototype.$adiSubmit = adiSubmit
export const liveSubmit = p => post(baseURL + 'page/gather0614/liveSubmit', p)
Vue.prototype.$liveSubmit = liveSubmit
export const tekSubmit = p => post(baseURL + 'page/gather0614/tek190815Submit', p)
Vue.prototype.$tekSubmit = tekSubmit
export const showChoose = p => post(baseURL + 'page/gather0614/showChoose', p)
Vue.prototype.$showChoose = showChoose
export const showIndex = p => post(baseURL + '/page/gather0614/index', p)
Vue.prototype.$showIndex = showIndex

export const sendCode190711 = p => post(baseURL + 'page/keysight190708/sendCode', p)
Vue.prototype.$sendCode190711 = sendCode190711
export const infoSubmit = p => post(baseURL + 'page/keysight190708/sdAndTekSubmit', p)
Vue.prototype.$infoSubmit = infoSubmit

export const sendCode190717 = p => post(baseURL + 'page/tekmeeting190717/sendCode', p)
Vue.prototype.$sendCode190717 = sendCode190717
export const formSubmit190717 = p => post(baseURL + 'page/tekmeeting190717/formSubmit', p)
Vue.prototype.$formSubmit190717 = formSubmit190717

export const submit190806 = p => post(baseURL + 'page/adi190806/submit', p)
Vue.prototype.$submit190806 = submit190806
export const sendCode190806 = p => post(baseURL + 'page/adi190806/sendCode', p)
Vue.prototype.$sendCode190806 = sendCode190806
export const getQuestion190806 = p => post(baseURL + 'page/adi190806/getQuestion', p)
Vue.prototype.$getQuestion190806 = getQuestion190806

export const submit190807 = p => post(baseURL + 'page/seminar190807/infoSubmit', p)
Vue.prototype.$submit190807 = submit190807
export const sendCode190807 = p => post(baseURL + 'page/seminar190807/sendCode', p)
Vue.prototype.$sendCode190807 = sendCode190807

export const submit190812 = p => post(baseURL + 'page/heilind190812/infoSub', p)
Vue.prototype.$submit190812 = submit190812
export const sendCode190812 = p => post(baseURL + 'page/heilind190812/sendCode', p)
Vue.prototype.$sendCode190812 = sendCode190812

export const dyesSubmit1 = p => post(baseURL + '', p)
Vue.prototype.$dyesSubmit1 = dyesSubmit1

export const dyesSubmit2 = p => post(baseURL + 'page/Tekdesign190830/activity', p)
Vue.prototype.$dyesSubmit2 = dyesSubmit2
export const sendCodeTekdesign190830 = p => post(baseURL + 'page/Tekdesign190830/sendCode', p)
Vue.prototype.$sendCodeTekdesign190830 = sendCodeTekdesign190830
export const dyesSubmit3 = p => post(baseURL + 'page/Tektdk190830/activity', p)
Vue.prototype.$dyesSubmit3 = dyesSubmit3
export const sendCodeTektdk190830 = p => post(baseURL + 'page/Tektdk190830/sendCode', p)
Vue.prototype.$sendCodeTektdk190830 = sendCodeTektdk190830
export const getPost3 = p => post(baseURL + 'page/Tektdk190830/community', p)
Vue.prototype.$getPost3 = getPost3

export const dyesSubmit4 = p => post(baseURL + 'page/Tekadi190830/activity', p)
Vue.prototype.$dyesSubmit4 = dyesSubmit4
export const sendCodeTekadi190830 = p => post(baseURL + 'page/tekadi190830/sendCode', p)
Vue.prototype.$sendCodeTekadi190830 = sendCodeTekadi190830
export const dyesSubmit5 = p => post(baseURL + 'page/Tekaditiezi190907/activity', p)
Vue.prototype.$dyesSubmit5 = dyesSubmit5
export const sendCodeTekaditiezi190907 = p => post(baseURL + 'page/Tekaditiezi190907/sendCode', p)
Vue.prototype.$sendCodeTekaditiezi190907 = sendCodeTekaditiezi190907
export const getPost5 = p => post(baseURL + 'page/Tekaditiezi190907/community', p)
Vue.prototype.$getPost5 = getPost5

export const sendCode0904 = p => post(baseURL + 'page/Act190904/sendCode', p)
Vue.prototype.$sendCode0904 = sendCode0904
export const infoSubmit0904 = p => post(baseURL + 'page/Act190904/infoSubmit', p)
Vue.prototype.$infoSubmit0904 = infoSubmit0904

export const submit190910 = p => post(baseURL + 'page/seminar190910/infoSubmit', p)
Vue.prototype.$submit190910 = submit190910

export const vicorSubmit190910 = p => post(baseURL + 'page/vicor190830/activity', p)
Vue.prototype.$vicorSubmit190910 = vicorSubmit190910
export const vicorSendCode190910 = p => post(baseURL + 'page/vicor190830/sendCode', p)
Vue.prototype.$vicorSendCode190910 = vicorSendCode190910

export const wbg190921 = p => post(baseURL + 'index.php/page/eestarlive190920/sendSms', p)
Vue.prototype.$wbg190921 = wbg190921
export const wbg190921getposition = p => post(baseURL + 'index.php/page/eestarlive190920/getPosition', p)
Vue.prototype.$wbg190921getposition = wbg190921getposition
export const wbg190921sendsms = p => post(baseURL + 'page/eestarlive190920/submit', p)
Vue.prototype.$wbg190921sendsms = wbg190921sendsms

export const weixinact190924 = p => post(baseURL + 'page/Newfriend190924/sendCode', p)
Vue.prototype.$weixinact190924 = weixinact190924
export const weixinact190924infoSubmit = p => post(baseURL + 'page/Newfriend190924/infoSubmit', p)
Vue.prototype.$weixinact190924infoSubmit = weixinact190924infoSubmit
export const getweixincode190924 = p => get('https://open.weixin.qq.com/connect/oauth2/authorize', p)
Vue.prototype.$getweixincode190924 = getweixincode190924
export const weixinact190924getInfo = p => post(baseURL + 'page/Newfriend190924/getInfo', p)
Vue.prototype.$weixinact190924getInfo = weixinact190924getInfo
export const getInfoByUnionid = p => post(baseURL + 'page/Newfriend190924/getInfoByUnionid', p)
Vue.prototype.$getInfoByUnionid = getInfoByUnionid

export const ni190927getcode = p => post(baseURL + 'page/Ni190926/sendCode', p)
Vue.prototype.$ni190927getcode = ni190927getcode
export const ni190927sendfrom = p => post(baseURL + 'page/ni190926/submit', p)
Vue.prototype.$ni190927sendfrom = ni190927sendfrom
export const ni190927getProfessor = p => post(baseURL + 'page/ni190926/getProfessor', p)
Vue.prototype.$ni190927getProfessor = ni190927getProfessor

export const infineon190925getcode = p => post(baseURL + 'page/infineon190926/sendCode', p)
Vue.prototype.$infineon190925getcode = infineon190925getcode
export const infineon190925sendfrom = p => post(baseURL + 'page/infineon190926/activity', p)
Vue.prototype.$infineon190925sendfrom = infineon190925sendfrom
export const infineon190925getProfessor = p => post(baseURL + 'page/Infineon190926/getProfessor', p)
Vue.prototype.$infineon190925getProfessor = infineon190925getProfessor

export const wbg190930button = p => post(baseURL + 'page/Eestarlive190930/button', p)
Vue.prototype.$wbg190930button = wbg190930button
export const wbg190930submit = p => post(baseURL + 'page/Eestarlive190930/submit', p)
Vue.prototype.$wbg190930submit = wbg190930submit

export const gather0614getProfessor = p => post(baseURL + 'page/gather0614/getProfessor', p) // 职称
Vue.prototype.$gather0614getProfessor = gather0614getProfessor

export const ni190919Submit = p => post(baseURL + 'page/gather0614/ni190919Submit', p)
Vue.prototype.$ni190919Submit = ni190919Submit

export const Infine190916Submit = p => post(baseURL + 'page/gather0614/Infine190916Submit', p)
Vue.prototype.$Infine190916Submit = Infine190916Submit

export const keysight191012Submit = p => post(baseURL + 'page/gather0614/keysight191012Submit', p)
Vue.prototype.$keysight191012Submit = keysight191012Submit

export const heilind191018getcode = p => post(baseURL + 'page/heilind191018/sendCode', p)
Vue.prototype.$heilind191018getcode = heilind191018getcode
export const heilind191018Submit = p => post(baseURL + 'page/heilind191018/infoSub', p)
Vue.prototype.$heilind191018Submit = heilind191018Submit

export const liveforecast191022getJobTitle = p => post(eestarURL + 'h5/Live/getJobTitle', p)
Vue.prototype.$liveforecast191022getJobTitle = liveforecast191022getJobTitle
export const liveforecast191022sendMsg = p => post(eestarURL + 'h5/Live/sendMsg', p)
Vue.prototype.$liveforecast191022sendMsg = liveforecast191022sendMsg
export const liveforecast191022liveAppointment = p => post(eestarURL + 'h5/Live/liveAppointment', p)
Vue.prototype.$liveforecast191022liveAppointment = liveforecast191022liveAppointment

export const Mps191024joinAct = p => post(baseURL + 'scrmpage/Mps191024/joinAct', p)
Vue.prototype.$Mps191024joinAct = Mps191024joinAct

export const Keysight191030joinAct = p => post(baseURL + 'scrmpage/Keysight191030/joinAct', p)
Vue.prototype.$Keysight191030joinAct = Keysight191030joinAct

export const Dahua191031joinAct = p => post(baseURL + 'scrmpage/Dahua191031/joinAct', p)
Vue.prototype.$Dahua191031joinAct = Dahua191031joinAct

export const mornsun191031getcode = p => post(baseURL + 'page/mornsun191031/sendCode', p)
Vue.prototype.$mornsun191031getcode = mornsun191031getcode
export const mornsun191031Submit = p => post(baseURL + 'page/mornsun191031/infoSub', p)
Vue.prototype.$mornsun191031Submit = mornsun191031Submit

export const oneself191101sendCode = p => post(baseURL + 'page/keysight191101/sendCode', p)
Vue.prototype.$oneself191101sendCode = oneself191101sendCode
export const oneself191101infoSubmit = p => post(baseURL + 'page/keysight191101/infoSubmit', p)
Vue.prototype.$oneself191101infoSubmit = oneself191101infoSubmit

export const artesyn191108sendCode = p => post(baseURL + 'scrmpage/Artesyn191108/sendCode', p)
Vue.prototype.$artesyn191108sendCode = artesyn191108sendCode
export const artesyn191108JoinAct = p => post(baseURL + 'scrmpage/Artesyn191108/joinAct', p)
Vue.prototype.$artesyn191108JoinAct = artesyn191108JoinAct

export const Mps191111sendCode = p => post(baseURL + 'scrmpage/Mps191111/sendCode', p)
Vue.prototype.$Mps191111sendCode = Mps191111sendCode
export const Mps191111JoinAct = p => post(baseURL + 'scrmpage/Mps191111/joinAct', p)
Vue.prototype.$Mps191111JoinAct = Mps191111JoinAct

export const getPost = p => post(baseURL + 'page/gather1107/getPost', p)
Vue.prototype.$getpost = getPost
export const getIndustry = p => post(baseURL + 'page/gather1107/getIndustry', p)
Vue.prototype.$getIndustry = getIndustry
export const analog191107Submit = p => post(baseURL + 'page/gather1107/analog191107Submit', p)
Vue.prototype.$analog191107Submit = analog191107Submit
export const fluke191107Submit = p => post(baseURL + 'page/gather1107/fluke191107Submit', p)
Vue.prototype.$fluke191107Submit = fluke191107Submit
export const vicor191107Submit = p => post(baseURL + 'page/gather1107/vicor191107Submit', p)
Vue.prototype.$vicor191107Submit = vicor191107Submit
export const showChoose1 = p => post(baseURL + 'page/gather1107/showChoose', p)
Vue.prototype.$showChoose1 = showChoose1
export const keysight191012Submit1 = p => post(baseURL + 'page/gather1107/keysight191012Submit', p)
Vue.prototype.$keysight191012Submit1 = keysight191012Submit1
export const formSubmit1 = p => post(baseURL + 'page/gather1107/formSubmit', p)
Vue.prototype.$formSubmit1 = formSubmit1
export const sendCode1 = p => post(baseURL + 'page/gather1107/sendCode', p)
Vue.prototype.$sendCode1 = sendCode1
export const getInfo1 = p => post(baseURL + 'page/gather1107/qrSubmit', p)
Vue.prototype.$getInfo1 = getInfo1

export const Keysight191108submit = p => post(baseURL + 'page/Keysight191108/submit', p)
Vue.prototype.$Keysight191108submit = Keysight191108submit
export const Keysight191108SendCode = p => post(baseURL + 'page/Keysight191108/sendCode', p)
Vue.prototype.$Keysight191108SendCode = Keysight191108SendCode

export const meeting191114submit = p => post(baseURL + 'page/seminar191114/infoSubmit', p)
Vue.prototype.$meeting191114submit = meeting191114submit
export const meeting191114sendCode = p => post(baseURL + 'page/seminar191114/sendCode', p)
Vue.prototype.$meeting191114sendCode = meeting191114sendCode

export const meeting191122GetQuestion = p => post(baseURL + 'scrmpage/meeting191122/getQuestion', p)
Vue.prototype.$meeting191122GetQuestion = meeting191122GetQuestion
export const meeting191122JoinAct = p => post(baseURL + 'scrmpage/meeting191122/joinAct', p)
Vue.prototype.$meeting191122JoinAct = meeting191122JoinAct

export const mps191203JoinAct = p => post(baseURL + 'scrmpage/Mps191203/joinAct', p)
Vue.prototype.$mps191203JoinAct = mps191203JoinAct

export const mps191216JoinAct = p => post(baseURL + 'scrmPage/Mps191216/joinAct', p)
Vue.prototype.$mps191216JoinAct = mps191216JoinAct
export const mps191216Isjoin = p => post(baseURL + 'scrmpage/Mps191216/is_join', p)
Vue.prototype.$mps191216Isjoin = mps191216Isjoin

export const mps191226GetQuestion = p => post(baseURL + 'scrmpage/meeting191226/getQuestion', p)
Vue.prototype.$mps191226GetQuestion = mps191226GetQuestion
export const mps191226JoinAct = p => post(baseURL + 'scrmpage/meeting191226/joinAct', p)
Vue.prototype.$mps191226JoinAct = mps191226JoinAct
export const mps191226isJoin = p => post(baseURL + 'scrmpage/meeting191226/is_join', p)
Vue.prototype.$mps191226isJoin = mps191226isJoin
